import { ADMIN_DASHBOARD_INSTRUCTIONS } from './constants';

export const es = {
  [ADMIN_DASHBOARD_INSTRUCTIONS]: {
    INSTRUCTIONS_STEP_1: 'Utiliza la plantilla en Excel',
    INSTRUCTIONS_STEP_1_LINK: 'Descargar plantilla',
    INSTRUCTIONS_STEP_2:
      'Ingresa el correo electrónico de tu usuarios.\nMáximo 500 usuarios por carga.',
    INSTRUCTIONS_STEP_3: 'Sube el archivo de Excel\ny dale a “Siguiente”.',
  },
};
